<div class="wrap-1200">
    <app-ir-to-assign-table
      [projectData]="projects"
      [loader]="loader">
    </app-ir-to-assign-table>
</div>
